import Router from 'next/router';
import { Message } from '@bijie/react-bnb';
import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import { eraseCookie, createCookie } from '../../utils/cookies-browser';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';
import { TOAST_FADE_TIME } from '../../config/constantNg';

const {
  FETCH_USER_INFO,
  SET_USER_INFO,
  FETCH_USER_INFO_ERROR,
  FETCH_KTC_INFO,
  FETCH_KTC_INFO_SUCCESS,
  FETCH_KTC_INFO_ERROR,
  SET_USER_LOGS,
  FETCH_USER_LOGS,
  FETCH_USER_LOGS_ERROR,
  FETCH_USER_CONFIG,
  FETCH_USER_CONFIG_SUCCESS,
  FETCH_USER_CONFIG_FAILED,
  FETCH_USER_ANTI_PHISHING_CODE,
  SET_USER_ANTI_PHISHING_CODE,
  FETCH_TRADE_INFO_SUCCESS,
  FETCH_USER_ANTI_PHISHING_CODE_ERROR,
  UPDATA_USER_COMMISSION_STATUS_SUCCESS,
  UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS,
  FETCH_USER_COMMISSTION_TOTAL,
  FETCH_USER_COMMISSTION_FIAT_TOTAL,
  FETCH_USER_COMMISSTION_DETAIL,
  FETCH_USER_REFERRAL_FRIENDS,
  FETCH_USER_REFERRAL_MONTHLY,
  SET_TOP_COMMISSION,
  SET_BASE_DETAIL,
  SET_CONFIRM_TIPS,
  SET_ACTIVITY_INFO,
  SET_MY_REFERRAL_REWARD_LIST,
} = actionTypes;

const setUserInfoData = createBaseActions(SET_USER_INFO, 'data');
const setKYCInfoData = createBaseActions(FETCH_KTC_INFO_SUCCESS, 'data');
const setUserLogsData = createBaseActions(SET_USER_LOGS, 'data');
const setUserConfigData = createBaseActions(FETCH_USER_CONFIG_SUCCESS, 'data');
const setUserAntiPhishingCode = createBaseActions(SET_USER_ANTI_PHISHING_CODE, 'data');
const setTradeInfoData = createBaseActions(FETCH_TRADE_INFO_SUCCESS, 'data');
const setUserCommissionStatus = createBaseActions(UPDATA_USER_COMMISSION_STATUS_SUCCESS, 'data');
const updataWithdrawWhiteStatus = createBaseActions(UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS, 'data');

const setUserCommissionTotal = createBaseActions(FETCH_USER_COMMISSTION_TOTAL, 'data');
const setUserCommissionFiatTotal = createBaseActions(FETCH_USER_COMMISSTION_FIAT_TOTAL, 'data');
const setUserReferralMonthly = createBaseActions(FETCH_USER_REFERRAL_MONTHLY, 'data');
const setUserCommissionDetail = createBaseActions(FETCH_USER_COMMISSTION_DETAIL, 'data');
const setUserReferralFriends = createBaseActions(FETCH_USER_REFERRAL_FRIENDS, 'data');
const setTopCommission = createBaseActions(SET_TOP_COMMISSION, 'data');
const setConfirmTips = createBaseActions(SET_CONFIRM_TIPS, 'data');
const setBaseDetail = createBaseActions(SET_BASE_DETAIL, 'data');
const setActivityInfo = createBaseActions(SET_ACTIVITY_INFO, 'data');
const setMyReferralRewardList = createBaseActions(SET_MY_REFERRAL_REWARD_LIST, 'data');


// const setCom

const fetchUserAntiPhishingCodeError = createBaseActions(
  FETCH_USER_ANTI_PHISHING_CODE_ERROR,
  'error'
);

export const handleUserInfo = data => {
  data = handleGwData(data) || {};
  return {
    ...data,
    isParentUser: data.parentUser,
    isSubUser: data.subUser,
    isExistMarginAccount: data.isExistMarginAccount,
    isSubUserEnabled: data.subUserEnabled,
    userData: {
      authenticationType: data.authenticationType,
      commissionStatus: data.commissionStatus,
      userId: data.userId,
    },
  };
};

export const fetchBaseDetail = async () => {
  let result = {};
  try {
    result = await gwPost(API_PATH.USER_INFO_API_PATH);
    result = handleUserInfo(result);
  } catch (error) {
    bog.error(`Error: fetchBaseDetail error, message is ${error.message}`);
  }
  return result;
};

export const fetchUserInfo = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_USER_INFO });
  const { locale } = getState();
  try {
    const userInfo = await fetchBaseDetail(locale);
    dispatch(setUserInfoData(userInfo));
  } catch (error) {
    dispatch({ type: FETCH_USER_INFO_ERROR, error });
  }
};

export const getKycInfoRequest = () => gwPost(API_PATH.GET_KYC_VALIDATE_INFO_API, setPostBody());
const getCurrentKycInfoRequest = () => gwPost(API_PATH.GET_CURRENT_KYC_VALIDATE_INFO_API, setPostBody());

export const fetchKycInfo = () => async dispatch => {
  dispatch({ type: FETCH_KTC_INFO });
  try {
    const data = await getCurrentKycInfoRequest();
    dispatch(setKYCInfoData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_KTC_INFO_ERROR, error });
  }
};

export const fetchUserLogs = (postData) => async dispatch => {
  dispatch({ type: FETCH_USER_LOGS });
  try {
    const data = await gwPost(API_PATH.USER_LOGS_API_PATH, postData);
    dispatch(setUserLogsData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_USER_LOGS_ERROR, error });
  }
};

export const getUserConfigRequest = req => gwPost(API_PATH.GET_USER_CONFIG_API, setPostBody(), req);

export const fetchUserConfig = () => async dispatch => {
  dispatch({ type: FETCH_USER_CONFIG });
  try {
    const data = await getUserConfigRequest();
    dispatch(setUserConfigData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_USER_CONFIG_FAILED, error });
  }
};

export const openWhiteListStatus = data => async dispatch => {
  const params = {
    authType: data.type,
    verifyCode: data.code,
  };
  try {
    const result = await gwPost(API_PATH.OPEN_WITHDRAW_WHITE_STATUS_API_PATH, setPostBody(params));
    if (result.success) {
      dispatch(updataWithdrawWhiteStatus(true));
      return Promise.resolve();
    }
    Message.fail(result.message, TOAST_FADE_TIME);
    return Promise.reject();
  } catch (error) {
    return Promise.reject();
  }
};

export const closeWhiteListStatus = data => async (dispatch, getState) => {
  const { locale } = getState();
  const api = API_PATH.CLOSE_WITHDRAW_WHITE_STATUS_API_PATH;

  const params = {
    authType: data.type,
    verifyCode: data.code,
  };
  try {
    const result = await gwPost(api, setPostBody(params));
    if (result.success) {
      Router.push(`/${locale}/usercenter/security/disable-withdraw-whiteList`);
      return Promise.resolve();
    }
    Message.fail(result.message, TOAST_FADE_TIME);
    return Promise.reject();
  } catch (error) {
    return Promise.reject();
  }
};

export const updateUserConfigRequest = data => {
  if (data.configType === 'language') {
    const saveLocale = data.configName || 'en';
    eraseCookie('lang');
    createCookie('lang', saveLocale.toUpperCase());
  }
  return gwPost(API_PATH.SAVE_USER_CONFIG_API_PATH, setPostBody(data));
};

export const fetchUserAntiPhishingCode = () => async dispatch => {
  dispatch({ type: FETCH_USER_ANTI_PHISHING_CODE });
  try {
    const api = API_PATH.ANTI_PHISHING_CODE_API_PATH;
    const data = await gwPost(api, { });
    dispatch(setUserAntiPhishingCode(handleGwData(data)));
  } catch (error) {
    dispatch(fetchUserAntiPhishingCodeError(error));
  }
};

export const sendSmsCode = async () => {
  const postData = setPostBody();
  const result = await gwPost(API_PATH.SEND_SMS_CODE_API_PATH, postData);
  return result;
};

export const updateCommissionStatus = status => async (dispatch) => {
  const postData = setPostBody({
    useBnbFee: status,
  });
  const api = API_PATH.SET_COMMISSION_STATUS_API_PATH;
  const result = await gwPost(api, postData);
  if (result.success) {
    dispatch(setUserCommissionStatus(status));
  }
};

export const fetchTradeLevelInfo = async (req, locale) => {
  let result = [];
  try {
    const api = API_PATH.TRADE_LEVEL_API_PATH;
    result = await makeOrCacheApiReq(
      api,
      () => gwGet(api, { locale }, req),
      res => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (e) {
    // nothing
  }
  return result;
};

export const fetchTradeNumber = () => async dispatch => {
  let result = {};
  try {
    result = await gwPost(API_PATH.TRADE_INFO_API_PATH);
    if (result.success) {
      dispatch(setTradeInfoData(result.data));
    }
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchCommissionDetail = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.COMMISSION_DETAIL_PATH, {
      locale,
      ...setPostBody({ ...data, page: 1, rows: 30 }),
    });
    result = handleGwData(result) || {};
    dispatch(setUserCommissionDetail(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const fetchReferralFriends = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.REFERRAL_FRIENDS, {
      locale,
      ...setPostBody({ ...data, page: 1, rows: 30 }),
    });
    result = handleGwData(result) || {};
    dispatch(setUserReferralFriends(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const getTopCommission = () => async dispatch => {
  try {
    let result = await gwGet(API_PATH.COMMISSION_TOP_PATH);
    result = handleGwData(result) || {};
    dispatch(setTopCommission(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const fetchCommissionRate = () => async (dispatch) => {
  try {
    let result = await gwPost(API_PATH.USER_INFO_API_PATH, {});
    result = handleGwData(result) || {};
    dispatch(setBaseDetail(result));
  } catch (error) {
    bog.error(`Error: fetchBaseDetail error, message is ${error.message}`);
  }
};

export const updateConfirmTips = () => async (dispatch) => {
  try {
    let result = await gwPost(API_PATH.CONFIRM_TIP, {});
    result = handleGwData(result) || {};
    dispatch(setConfirmTips(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const setCoinApply = (data) => async () => {
  try {
    const result = await gwPost(API_PATH.COIN_APPLY_PATH, data);
    return result;
  } catch (error) {
    bog.error(`Error: set coin apply error, message is ${error.message}`);
  }
  return {};
};

export const fetchCommissionTotal = () => async (dispatch) => {
  try {
    let result = await gwPost(API_PATH.COMMISSION_TOTAL_PATH, {});
    result = handleGwData(result) || {};
    dispatch(setUserCommissionTotal(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const fetchCommissionFiatTotal = () => async (dispatch) => {
  try {
    let result = await gwPost(API_PATH.COMMISSION_FIAT_TOTAL_PATH, {});
    result = handleGwData(result) || {};
    dispatch(setUserCommissionFiatTotal(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const fetchReferralMonthly = () => async (dispatch) => {
  try {
    let result = await gwGet(API_PATH.REFERRAL_MONTHLY, {});
    result = handleGwData(result) || {};
    dispatch(setUserReferralMonthly(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const getActivityInfo = () => async (dispatch) => {
  try {
    let result = await gwGet(API_PATH.ACTIVITY_INFO);
    result = handleGwData(result) || {};
    dispatch(setActivityInfo(result));
  } catch (error) {
    bog.error(`Error: getActivityInfo error, message is ${error.message}`);
  }
};

export const getMyReferralRewardList = (page = 1) => async (dispatch) => {
  try {
    let result = await gwGet(`${API_PATH.MY_REFERRAL_REWARD_LIST}?page=${page}&rows=20`);
    result = handleGwData(result) || {};
    dispatch(setMyReferralRewardList(result));
  } catch (error) {
    bog.error(`Error: getMyReferralRewardList error, message is ${error.message}`);
  }
};
